import React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import "./skeleton.css";

export const CarouselSkeleton = () => {
  return (
    <div  className='carousel-skeleton' > 
            <Skeleton width={"100%"} height={"100%"} borderRadius={"15px"}  />
    </div>
  )
}

export const StoreSkeleton = () => {
  return (
    <div  className='store-skeleton' > 
        <div className='store-image-skeleton' > 
                <Skeleton width={"100%"} height={"100%"} borderRadius={"10px" }   />
        </div>
        <div className='store-info-skeleton' >
            <Skeleton className='info-skeleton'  width={"100%"} height={"12px"}  borderRadius={"10px"}  />
            <Skeleton className='info-skeleton'  width={"100%"} height={"12px"} borderRadius={"10px"}  />
            <Skeleton  className='info-skeleton'  width={"60px"} height={"18px"}  borderRadius={"40px"} margin ={"1rem"}  />
        </div>
    </div>
  )
}

export const ItemSkeleton = () => {
  return (
    <div  className='store-skeleton' > 
        <div className='store-info-skeleton' >
            <Skeleton className='food-type-skeleton' width={"30px"} height={"23px"} borderRadius={"5px"}  />
            <Skeleton  width={"100%"} height={"13px"}  borderRadius={"6px"}  />
            <Skeleton  className='food-info-skeleton' width={"70%"} height={"12px"} borderRadius={"10px"}  />
        </div>
        <div className='rest-image-skeleton' > 
                <Skeleton width={"100%"} height={"100%"} borderRadius={"10px" }   />
        </div>
    </div>
  )
}


export const RestSkeleton = () => {
  return (
    <div  className='rest-skeleton' > 
        <div className='rest-info-skeleton' >
            <Skeleton className='rest-title-skeleton'   borderRadius={"40px"}   />
            <Skeleton className='rest-rating-skeleton'  width={"60px"} height={"12px"} borderRadius={"10px"}  />
        </div>
        <Skeleton className='food-type-skeleton'  width={"120px"} height={"12px"}  borderRadius={"10px"}  />
    </div>
  )
}